import React, { useState, useEffect, useCallback } from 'react';
import { Header } from "../comp/Header";
import { Category, CategorySidebar } from "../comp/CategorySidebar";
import { ProductCard } from "../comp/ProductCard";
import { ProductListItem } from "../comp/ProductListItem";
import { CartSheet } from "../comp/CartSheet";
import { ProductDetailDialog } from "../comp/ProductDetailDialog";
import { toast } from "sonner";
import { Toaster } from "../comp/ui/sonner";
import { Button } from "../comp/ui/button";
import { LayoutGrid, LayoutList, Search } from "lucide-react";
import { CatalogItem, CatalogItemListReq, PropertyFilter } from '../types/catalog'; // Adjust path if needed
import { catalogClient } from '../services/grpc'; // Adjust path to your gRPC client
import * as pb from '../generated/catalog_pb'; // From generated proto (adjust path)
import { PropertyFilter as GrpcPropertyFilter,CatalogItemListReq as GrpcCatalogItemListReq } from '../generated/catalog_pb'; 
import Cookies from 'js-cookie';
import { CartItem, ShoppingCart } from '../comp/ShoppingCart';
import { Pagination } from '../Components/Paginator';
import { useParams } from 'react-router-dom';
import Aksessuary from "../comp/icons/Aksessuary"
import Climat from "../comp/icons/Climat"
import Engine from "../comp/icons/Engine"
import Tormoza from "../comp/icons/Tormoza"
import Electric from "../comp/icons/Electric"
import Khodovaya from "../comp/icons/Khodovaya"
import Kpp from "../comp/icons/Kpp"
import Kuzov from "../comp/icons/Kuzov"
import Filtres from "../comp/icons/Filtres"
import Rulevoe from "../comp/icons/Rulevoe"
import Salon from "../comp/icons/Salon"
import Sceplenie from "../comp/icons/Sceplenie"
import Ext from "../comp/icons/Ext"
import Glasses from "../comp/icons/Glasses"
import All from "../comp/icons/Logo"
import Box from "../comp/icons/Box"
import ModelsSection from '../comp/ModelList';
import Model from '../comp/ModelList';
import { NewHeader } from '../comp/NewHeader';
import { Footer } from '../comp/Footer';
export default function App() {  
  const { id, model } = useParams<{ id?: string; model?: string }>();
  const categories: Category[] = [
  { name: "Главная", icon: All,code:"All"},
  { name: "Тормоза", icon: Tormoza,code:"Tormoznaia_sistema"},
  { name: "ДВС", icon: Engine,code:"dvigatel"},
  { name: "Климатическая система", icon: Climat,code:"klimaticheskaya-sistema"},
  { name: "Кузовные элементы", icon: Kuzov,code:"kuzovnye-ehlementy"},
  { name: "Электрика ", icon: Electric,code:"ehlektrika"},
  { name: "Аксессуары", icon: Aksessuary,code:"aksessuary"},
  { name: "Фильтры", icon: Filtres,code:"filtry"},
  { name: "Стекло", icon: Glasses,code:"Steklo"},
   { name: "Подвеска", icon: Khodovaya,code:"podveska"},
    { name: "КПП", icon: Kpp,code:"transmissiyakpp"},
     { name: "Рулевое", icon: Rulevoe,code:"rulevoe-upravlenie"},
      { name: "Интерьер", icon: Salon,code:"interer"},
       { name: "Сцепление", icon: Sceplenie,code:"sceplenie"},
       { name: "Экстерьер", icon: Ext,code:"ehksterer"},
       { name: "Другое", icon: Box,code:"other"},
];
  //const [products, setProducts] = useState<Product[]>([]);
  const [products, setProducts] = useState<CatalogItem[]>([]);
  const [cart, setCart] = useState<CatalogItem[]>([]);
  const [selectedCategory, setSelectedCategory] = useState<Category>(categories[0]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<CatalogItem | null>(null);
  const [loading, setLoading] = useState(true);
  const [viewMode, setViewMode] = useState<"grid" | "list">("list");
  const [isAccountOpen, setIsAccountOpen] = useState(false);
  const [userGuid, setUserGuid] = useState<string>("");
  const [pageCount, setPageCount] = useState(0); 
  const [currentPage, setCurrentPage] = useState(0);
  const [limit] = useState(20); 
  const [sortConfig, setSortConfig] = useState("name asc");
  const [alertMessage, setAlertMessage] = useState<string | null>(null);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [isInCartStorage, setIsInCartStorage] = useState<string[]>([]);
  const [cartItems, setCartItems] = useState<CartItem[]>([]);
  const [customerName, setCustomerName] = useState('');
  const [customerPhone, setCustomerPhone] = useState('');
  const [cartItemCount, setCartItemCount]= useState(0);
  const [cartTotalPrice, setCarttotalPrice]= useState(0);
  const [selectedModel, setSelectedModel] = useState<string>('');
  const [IsMobileCatalogOpen, setIsMobileCatalogOpen] = useState(false);
  
   const makeFilter = (code: string, command: string, val: unknown) => {
      if (val === undefined || val === null) return null;
      let s = '';
      if (Array.isArray(val)) s = val.join('_');
      else s = String(val).trim();
      if (!s || s.toLowerCase() === 'all') return null;
  
      const pf = new GrpcPropertyFilter();
      pf.setCode(code);
      pf.setCommand(command);
      pf.setSearch(s);
      return pf;
    };
  useEffect(() => {
    initializeApp();
  }, []);

useEffect(() => {
  const categoryCode = id?.trim() || "all";
  const found = categories.find(c => c.code === categoryCode) || categories[0];
  setSelectedCategory(found);
  const currentModel = model?.trim() ? decodeURIComponent(model.trim()) : "";
  setSelectedModel(currentModel);
  setIsMobileCatalogOpen(false);
  fetchProducts(found.code, currentPage, currentModel,searchQuery);
}, [id, model, currentPage,searchQuery]);
 
useEffect(() => {
  initializeApp();
}, []);

  const initializeApp = async () => {
  let isguid = Cookies.get('guid');
  if (typeof isguid != 'string') {
    const req= new pb.guidReq();  
   
    req.setIp(window.location.hostname);
    catalogClient.getGuid(req, {}, (err, response) => {
      if (err) {
        console.error('Error fetching guid:', err.code, err.message);
      } else {
        Cookies.set('guid', response.getGuid());
      }
    });
  }
  const guid = Cookies.get('guid');
 
  };


  const fetchProducts = async (  
    catalogCode: string,
    page: number,
    modelFilter: string,
    search:string) => {
    setLoading(true);

    try {
     const guid = Cookies.get('guid')||'';
     const filters: GrpcPropertyFilter[] = [];
     const req = new pb.CatalogItemListReq();
      req.setGuid(guid);
      req.setCatalogCode(catalogCode);
      if (search!=""){
        req.setSearch(search);
      }
      req.setPage(page);
      req.setLimit(limit);
      req.setOrder(sortConfig);
       if (modelFilter) {
        const grpcBrend:any=makeFilter('model', 'in', modelFilter);
         filters.push(grpcBrend);
         req.setPropFiltersList(filters);      // ← Send model if selected
      } else {
      req.setPropFiltersList([]);
      }
      const response = await new Promise<any>((resolve, reject) => {
        catalogClient.getCatalogItemList(req, {}, (err, res) => {
          if (err) reject(err);
          else resolve(res);
        });
      });

      var inCar:string[]=[];
     // const items = response.getItemsList().map((item: pb.CatalogItem) => item);
      const mappedItems: CatalogItem[] = response.getItemsList().map((item: pb.CatalogItem)=> ({
                  code: item.getCode(),
                  name: item.getName(),
                  desc: item.getDesc(),
                  title: item.getTitle(),
                  pic: item.getPic(),
                  id:item.getId(),
                  price:item.getPrice(),
                  qty:item.getQty(),
                  props: {
                    prop: item.getProps()?.getPropList().map(p => ({
                      code: p.getCode(),
                      name: p.getName(),
                      value: p.getValue(),
                    })) || []
                  },
                   storage:item.getStoragelistList().map(p=>({
                    storage: p.getStorage(),
                    price: p.getPrice(),
                    qty: p.getQty(),
                    incart:p.getIncart(),
                    })) || [],
                }));
      setProducts(mappedItems);
      setTotalCount(response.getCnt());
      setTotalPages(response.getTotalPages());
      setPageCount(Math.ceil(totalPages / limit));
      const inCart = mappedItems.flatMap(product =>
        product.storage
        ?.filter(stock => stock.incart)
        .map(stock => `${product.id}_${stock.storage}`) || []
        );
        setIsInCartStorage(inCart);
    } catch (error) {
      console.error("Error fetching products via gRPC:", error);
      toast.error("Failed to load products. Using sample data.");
    } finally {
      setLoading(false);
    }
  };


  const addToCart = (selectitem:CatalogItem,storage:string,price:number) => {
      try {
        const guid = Cookies.get('guid');
        if (typeof guid === 'string') {
          const req = new pb.CartAddReq();
          req.setGuid(guid);
          req.setProductId(selectitem.id);
          req.setQty(selectitem.qty+1);
          req.setStorage(storage);
          catalogClient.cartAdd(req, {}, (err, response) => {
            if (err) {
              console.error('Error adding to cart:', err.code, err.message);
            }
          });
        }
           setCartItems(prev => {
      const safeCartItems = prev || [];
      const existingItem = safeCartItems.find(
        item => item.product.id === selectitem.id && item.storage === storage
      );

      if (existingItem) {
        return safeCartItems.map(item =>
          item.product.id === selectitem.id && item.storage === storage
            ? { ...item, quantity: item.quantity + 1, storage: storage,price: item.price }
            : item
        );
      }
      setIsInCartStorage(prev => [...prev, `${selectitem.id}_${storage}`]);
 
      return [
        ...safeCartItems,
        { product: selectitem, quantity: 1, storage: storage, price:price }
      ];
    });
      } catch (error) {
        console.error('Error adding to cart:', error)
      }
    }
  
    const updateQuantity = (porodId: number, quantity: number,storage:string) => {
      try {
        if (quantity === 0) {
          removeFromCart(porodId,storage)
          return
        }
        const guid = Cookies.get('guid');
        if (typeof guid === 'string') {
          const req = new pb.CartAddReq();
          req.setGuid(guid);
          req.setProductId(porodId);
          req.setQty(quantity);
          req.setStorage(storage);
          catalogClient.cartUpdate(req, {}, (err, response) => {
            if (err) {
              console.error('Error adding to cart:', err.code, err.message);
            }
          });
        }
        setCartItems(prev => {
          const safeCartItems = prev || []
          return safeCartItems.map(item =>
            item.product.id === porodId && item.storage === storage ? { ...item, quantity,storage } : item
          )
        })
      } catch (error) {
        console.error('Error updating quantity:', error)
      }
    }
   
    const removeFromCart = (porodId: number,storage:string) => {
      try {
        const guid = Cookies.get('guid');
        if (typeof guid === 'string') {
        const req = new pb.CartRemoveReq();
        req.setGuid(guid);
        req.setProductId(porodId);
        req.setQty(0);
        req.setStorage(storage);
        catalogClient.cartRemove(req, {}, (err, response) => {
          
          if (err) {
            console.error('Error removing from cart:', err.code, err.message);
          }
        });
      }
        setCartItems(prev => {
          const safeCartItems = prev || []
          return safeCartItems.filter(item => !(item.product.id === porodId && item.storage === storage))
        });
         setIsInCartStorage(prev => prev.filter(s => s !== `${porodId}_${storage}`));
      } catch (error) {
        console.error('Error removing from cart:', error)
      }
    }
  const OnsetIsInCartStorage=(items:string[])=>{
    setIsInCartStorage(prev => items);
  }
  const setOrder = ()=>{
      if (!customerName || !customerPhone) {
        setAlertMessage(`Пожалуйста. Введите Ваше имя и номер телефона для связи`);
        return;
    }
  
      const guid = Cookies.get('guid');
      if (typeof guid === 'string') {
        const req=new pb.OrderAcceptReq();
        req.setGuid(guid);
        req.setName(customerName);
        req.setPhone(customerPhone);
        catalogClient.orderAccept(req, {}, (err, response) => {
          if (err) {
            console.error('Error removing from cart:', err.code, err.message);
          } else {
          if (response.getStatus()=="fail") { 
            setAlertMessage(`${response.getMessage()}`);
          } else {
            setAlertMessage(`Спасибо за заказ.\n\ 
              В ближайшее время наш менеджер свяжется с Вами.\n\ 
              Номер вашего заказа: ${response.getNum()}`);
            setCartItems([]);
            setIsCartOpen(false);
            setIsInCartStorage([]);
          }
            return;
          }
        });
      }
    }




  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-white">
      <Toaster position="top-right" />
      
      <NewHeader 
        cartItemCount={cartItemCount}
        onCartClick={() => setIsCartOpen(true)}
        onAccountClick={() => setIsAccountOpen(true)}
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery} page={''}        
      />

      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {/* Sidebar */}
            <button
                onClick={() => setIsMobileCatalogOpen(!IsMobileCatalogOpen)}
                className={`flex items-center gap-2 px-6 py-3 bg-[#155DFC] hover:bg-blue-700 rounded-lg transition-colors text-[20px] text-white/90 md:hidden`}
              >
              <LayoutGrid className="h-5 w-5" /> Каталог
              </button>
          <aside className={`md:col-span-1 align-self-start ${IsMobileCatalogOpen?"md:hidden":"hidden md:block"}`}>
            <CategorySidebar
              selectedCategory={selectedCategory}
              onCategorySelect={setSelectedCategory}
              categories={categories}
            />
          </aside>

          {/* Main Content */}
          <main className="md:col-span-3">
            <div className="mb-6">
              <div>
                <h2 className="text-3xl font-bold text-blue-900">
                  {selectedCategory?.code === "All" ? "" : selectedCategory?.name}
                </h2>
                <p className="text-gray-600 mt-1">
                  {products.length}  из {totalCount}
                </p>
                <ModelsSection
                 categories={categories}
                />
              </div>
            </div>

            {loading ? (
              <div className={viewMode === "grid" 
                ? "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" 
                : "space-y-4"
              }>
                {[...Array(6)].map((_, i) => (
                  <div 
                    key={i} 
                    className={`bg-gray-200 animate-pulse rounded-lg ${viewMode === "grid" ? "h-96" : "h-48"}`}
                  />
                ))}
              </div>
            ) : products.length === 0 ? (
              <div className="text-center py-20">
                <p className="text-xl text-gray-500">Товары не найдены</p>
                <p className="text-sm text-gray-400 mt-2">Попробуйте найти в другой категории</p>
              </div>
            ) : viewMode === "grid" ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {products.map((product) => (
                  <ProductCard
                    key={product.id}
                    product={product}
                    onAddToCart={addToCart}
                    onViewDetails={setSelectedProduct}
                  />
                ))}
              </div>
            ) : (
              <div className="space-y-4">
                {products.map((product) => (
                  <ProductListItem
                    key={product.id}
                    product={product}
                    onAddToCart={addToCart}
                    onViewDetails={setSelectedProduct}
                    isInCartStorage={isInCartStorage}
                  />
                ))}
              </div>
            )}
            {totalCount && (
                            <div className="flex justify-center mt-8">
                             {!loading && products.length > 0 && (
                         <Pagination 
              pageCount={totalPages} 
              currentPage={currentPage}
              onPageChange={(selectedPage) => {
                setCurrentPage(selectedPage); 
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }} 
            />
                    )}
                            </div>
                          )}
          </main>
        </div>
      </div>
 <Footer/>
      {/* Cart Sheet */}
      {Array.isArray(cartItems) && (
              <ShoppingCart
                isOpen={isCartOpen}
                onOpenChange={setIsCartOpen}
                cartItems={cartItems}
                onUpdateQuantity={updateQuantity}
                onRemoveItem={removeFromCart}
                onOrder={setOrder}
                customerName={customerName}
                customerPhone={customerPhone}
                setCustomerName={setCustomerName}
                setCustomerPhone={setCustomerPhone}
                setCartItemCount={setCartItemCount}
                setIsInCartStorage={OnsetIsInCartStorage}
              />
            )}

      {/* Product Detail Dialog */}
      <ProductDetailDialog
        product={selectedProduct}
        isOpen={selectedProduct !== null}
        onClose={() => setSelectedProduct(null)}
        onAddToCart={addToCart}
      />
    </div>
  );
}